import React from "react";
import { Card, CardContent, CardHeader, Divider, Grid, Typography } from '@material-ui/core';
import {
  EntityLayout,
  AboutField,
} from '@backstage/plugin-catalog';
import { EaPackDomainEntityV1beta1 } from '@internal/plugin-ea-pack-common';
import { MarkdownContent } from '@backstage/core-components';
import { useEntity } from '@backstage/plugin-catalog-react';
import { UserAndTitleField } from "../UserCard";
import { ValueStreamsAndBusinessCapabilitiesTab } from "./ValueStreamsAndBusinessCapabilitiesTab";

export const EnterpriseLayerEntityLayout = (props: { children?: React.ReactNode, gemcheckCard?: React.ReactNode }) => {
  const entity = useEntity().entity as EaPackDomainEntityV1beta1;
  const roles = entity.spec.roles;

  return (
    <EntityLayout parentEntityRelations={["partOf"]}>
      <EntityLayout.Route path="/" title="Overview">
        <Grid container spacing={3} alignItems="stretch">
          <Grid item md={6}>
            <Card>
              <CardHeader title="About" />
              <Divider />
              <CardContent>
                <Grid container>
                  <Grid item xs={12}>
                    <AboutField label="Description">
                      <MarkdownContent content={entity?.metadata?.description || 'No description'} />
                    </AboutField>
                  </Grid>
                  <Grid item xs={6}>
                    <AboutField label="Category">
                      <Typography>{entity.spec.category ?? 'Not set'}</Typography>
                    </AboutField>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>
          <Grid item md={6}>
            <Grid container spacing={3}>
              <Grid item md={12}>
                <Card>
                  <CardHeader title="The Team" />
                  <Divider />
                  <CardContent>
                    <Grid container>
                      <UserAndTitleField user={roles?.domainLead} title="Lead" onlyAvatar={false} gridSizes={{ xs: 6 }} />
                      {/* <UserAndTitleField user={roles?.enterpriseArchitect} title="Enterprise Architect" onlyAvatar={false} gridSizes={{ xs: 6 }} />
                  <UserAndTitleField user={roles?.engineeringLead} title="Engineering" onlyAvatar={false} gridSizes={{ xs: 6 }} />
                  <UserAndTitleField user={roles?.deliveryLead} title="Delivery" onlyAvatar={false} gridSizes={{ xs: 6 }} /> */}
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item md={12}>
                {props.gemcheckCard}
              </Grid>
            </Grid>
          </Grid>
          <Grid item md={12}>
            <ValueStreamsAndBusinessCapabilitiesTab />
          </Grid>
        </Grid>
      </EntityLayout.Route>
      {props.children}
    </EntityLayout>
  );
};
